<template>
  <q-list>
    <FileListItem
      v-for="(file, index) in computedFiles"
      :key="index"
      :file="file"
      :removing="removing"
      :removable="removalAllowed"
      @view="viewFile(file)"
      @remove="confirmRemoval(file)"
    />
  </q-list>
</template>

<script setup>
import { useQuasar } from "quasar";

import PConfirmDialog from "src/components/PConfirmDialog.vue";
import { FILE_TYPE_MAP } from "assets/scripts/utilities/constants";

const $q = useQuasar();

const { viewFile } = useFile();

const fileStore = useFileStore();
const purchaseOrderStore = usePurchaseOrderStore();

const { user } = storeToRefs(useAuthStore());
const { purchaseOrder } = storeToRefs(usePurchaseOrderStore());

const props = defineProps({
  entity: {
    type: Object,
    default: () => {
      return {};
    },
  },
  files: {
    type: Array,
    default: () => [],
  },
  fileType: {
    type: String,
    default: "",
  },
  removalAllowed: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

const computedFiles = computed(() => {
  if (props.files.length) {
    return props.files;
  }

  let files = [];

  if (route.name === "sales-purchase-orders") {
    files = unref(purchaseOrder)?.po_file;
  } else {
    files = unref(purchaseOrder)?.files;
  }

  return files?.filter(
    (file) =>
      file.status_cd === "active" &&
      file.file_type === props.fileType &&
      file[FILE_TYPE_MAP[props.fileType]?.key] === props.entity._id,
  );
});

const removing = ref(false);

const remove = async (_id) => {
  try {
    removing.value = true;

    if (route.name === "sales-purchase-orders") {
      await fileStore.removeFile(_id, user._id);

      await purchaseOrderStore.getPurchaseOrders();
    } else {
      await purchaseOrderStore.removeFile(_id, user._id);
    }
  } catch (error) {
    console.error(error);
  } finally {
    removing.value = false;
  }
};

const confirmRemoval = (file) => {
  const { _id, file_name } = file;

  if (!user) {
    return;
  }

  $q.dialog({
    component: PConfirmDialog,
    componentProps: {
      title: "Remove File",
      text: "Are you sure you want to remove this file ?",
      label: file_name,
      isFooterVisible: true,
      submitLabel: "Yes",
      cancelLabel: "No",
      onConfirm: () => remove(_id),
    },
  });
};
</script>
